function SvgPlus(props) {
  return (
    <svg
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.82 6.82h-5v5H5.18v-5h-5V5.18h5v-5h1.64v5h5v1.64z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgPlus
